import { useState } from "react"
import { WorkspaceBoardCard } from "./WorkspaceBoardCard.jsx"
import { TemplateCard } from "./TemplateCard.jsx"
import { WorkspaceBoardCardSkeleton } from "./WorkspaceBoardCardSkeleton"
import { AsyncTaskUI } from "@/modern/components/async-tasks/async-task-ui"
import { Badge } from "/src/modern/components/ui/badge.tsx"
import { Button } from "/src/modern/components/ui/button.tsx"

export function BoardSection({
  title,
  description,
  icon,
  boards = [],
  templates = [],
  onWorkforceActiveChange,
  onBoardAccess,
  defaultExpanded = true,
  isTemplateSection = false,
  showDuplicationSkeletons = false,
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const itemCount = isTemplateSection ? templates.length : boards.length

  if (boards.length > 0) {
    return (
      <div className="space-y-swivu-vertical-base">
        {/* Section Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              {icon}
              <h2 className="text-2xl font-semibold text-foreground">{title}</h2>
              <Badge variant="secondary" className="text-sm">
                {itemCount}
              </Badge>
            </div>
          </div>

          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-muted-foreground hover:text-foreground flex items-center !gap-swivu-horizontal-base"
          >
            <i className={`fa ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"} w-4 h-4`}></i>
            {isExpanded ? "Collapse" : "Expand"}
          </Button>
        </div>

        <p className="text-muted-foreground text-swivu-base mb-swivu-base">{description}</p>

        {/* Content Grid */}
        {isExpanded && (
          <div className="grid lg:grid-cols-2 xl:grid-cols-4 gap-swivu-base">
            {showDuplicationSkeletons && (
              <AsyncTaskUI.Loader>
                <WorkspaceBoardCardSkeleton />
              </AsyncTaskUI.Loader>
            )}
            {isTemplateSection
              ? templates.map((template, index) => (
                <TemplateCard key={index} {...template} />
              ))
              : boards.map((board, index) => (
                <WorkspaceBoardCard
                  key={board.id || index}
                  board={board}
                  onWorkforceActiveChange={onWorkforceActiveChange}
                  onBoardAccess={onBoardAccess}
                />
              ))}
          </div>
        )}
      </div>
    )
  }
}
